document.addEventListener("DOMContentLoaded", () => {
  const lensProduct = window.lensProduct;
  if (!lensProduct || !lensProduct.variants) {
    return;
  }
  const variants = lensProduct.variants;

  const updateState = (lensColorOverride = null) => {
    if (lensProduct.options.length < 2) return;
    const option1 =
      "lenscolor-" + lensProduct.options[0].toLowerCase().replace(/ /g, "-"); // Assuming option 1 is the lens color
    const option2 =
      "lensoption-" + lensProduct.options[1].toLowerCase().replace(/ /g, "-"); // Assuming option 2 is the lens material

    // The <span> inside .lenscolor-* is server-rendered and never updates client-side.
    // Prefer the value passed in from the variant:change event; fall back to the span only on initial load.
    let lensColor;
    if (lensColorOverride !== null) {
      lensColor = lensColorOverride;
    } else {
      const lensColorEl = document.querySelector("." + option1 + " span");
      if (!lensColorEl) return;
      lensColor = lensColorEl.innerHTML.trim();
    }

    const allowedMaterials = variants
      .filter((variant) => variant.options[0] === lensColor)
      .map((variant) => variant.options[1]);

    let resetToFirstOption = false;
    let firstOption = null;
    let counter = 0;
    document.querySelectorAll("." + option2 + " label").forEach((label) => {
      if (allowedMaterials.includes(label.innerText.trim())) {
        label.style.display = "flex";
        counter++;
        // click on this lable
        if (!firstOption) firstOption = label;
      } else {
        label.style.display = "none";
        // TODO CHECK IF THIS IS THE SELECTED OPTION AND HANDLE IT
        if (
          label.querySelector("input") &&
          label.querySelector("input").checked
        ) {
          resetToFirstOption = true;
        }

        if (
          document.getElementById(label.getAttribute("for")) &&
          document.getElementById(label.getAttribute("for")).checked
        ) {
          resetToFirstOption = true;
        }
      }
    });

    if (resetToFirstOption && firstOption) {
      firstOption.click();
    }

    // // hide the options
    if (counter === 1) {
      document.querySelector("." + option2).style.display = "none";
    } else {
      document.querySelector("." + option2).style.display = "flex";
    }

    // hide everything
    // if (counter === 1){
    //   document.querySelector("." + option2).closest("fieldset").style.display = "none";
    // }
    // else{
    //   document.querySelector("." + option2).closest("fieldset").style.display = "grid";
    // }
  };

  // Initialize using the server-rendered span (correct on first load)
  updateState();

  // The lensProduct color values (e.g. "Clear", "Amber") — used to identify which
  // option on the main product variant corresponds to the lens color.
  const lensProductColorValues = [
    ...new Set(variants.map((v) => v.options[0])),
  ];

  document.addEventListener("variant:change", (event) => {
    // Read the lens color directly from the variant so we don't depend on the
    // static server-rendered <span> which never updates client-side.
    const variant = event.detail?.variant;
    let lensColorFromVariant = null;
    if (variant?.options) {
      lensColorFromVariant =
        variant.options.find((o) => lensProductColorValues.includes(o)) ?? null;
    }
    updateState(lensColorFromVariant);
  });
});
